<script setup lang="ts">
import UserMenu from '@/components/layout/UserMenu.vue'
</script>

<template>
  <header class="h-full bg-foreground xs:block">
    <nav
      class="flex h-full items-center justify-end border-b-2 border-border bg-background pr-3 dark:border-gray-700 dark:bg-navy"
    >
      <UserMenu />
    </nav>
  </header>
</template>

<style scoped></style>
